import React from 'react';
import './TraceProgress.css';

const TraceProgress = ({ status, progress, currentStep, error }) => {
  if (!status) return null;

  return (
    <div className="trace-progress">
      <div className="progress-header">
        <h3>Trace in Progress</h3>
        <span className={`status-badge status-${status}`}>
          {status.toUpperCase()}
        </span>
      </div>

      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill"
          style={{ width: `${progress}%` }}
        >
          <span className="progress-text">{progress}%</span>
        </div>
      </div>

      {currentStep && (
        <div className="current-step">
          <span className="step-icon">⏳</span>
          {currentStep}
        </div>
      )}

      {error && (
        <div className="error-message">
          <span className="error-icon">❌</span>
          {error}
        </div>
      )}

      {status === 'completed' && (
        <div className="success-message">
          <span className="success-icon">✅</span>
          Trace completed successfully!
        </div>
      )}
    </div>
  );
};

export default TraceProgress;
